import { DataBean } from "../DataBean";

export class LoanCurrency extends DataBean{


    public async getLoanCurrencyCatalog(id:any):Promise<any>
    {
        return this.getCustomService("QuickDataERPCore","java.util.List_getLoanCurrencyCatalog_Number",[id]);
    }
}